import { CheckoutContract } from './checkout-contract.interface';
import { CheckoutItem } from './checkout-item.interface';
import { CheckoutPerson } from './checkout-person.interface';

export interface CheckoutPayload {
  businessEventCode: string;
  businessSource: string;
  channelCode: string;
  clientCode: string;
  contract: CheckoutContract;
  interactionId: string;
  item: CheckoutItem[];
  journeyCode: string;
  person: CheckoutPerson;
  quoteId: string;
  systemCode: string;
  userId: string;
}
